/* Ranking List */
function rankingli(callback,append){
var rankinglist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
	 	var cap;
    		for(var i=0; i < len; i++){

              if(json[i].cap){
                  caption = '<p class="comment">' + json[i].cap + '</p>'
              } else {
                  caption = ''
              }

              rankinglist = '<li class="' + json[i].rank + '">' + '<a href="' + json[i].url_o + '" target="_top">' + '<div class="rankimg"><img src="' + json[i].img + '"></div>' + '<div class="recommend_l"><p class="name abbr">' + json[i].name1 + '</p>' + caption + '</div></a></li>';
              $(append).append(rankinglist);
   			}
		}
    })
};